/*=============================================== HelpersPage ===============================================*/

import { camelToCapitalize, uuid, Table } from "tsx-library-julseb"

import { ComponentsLayout } from "components"

import { allHelpers } from "data"

const HelpersPage = () => {
    const headers = Object.keys(allHelpers[0]).map(header =>
        camelToCapitalize(header)
    )

    return (
        <ComponentsLayout>
            <Table headers={headers} variant="border-bottom" vAlign="top">
                {allHelpers.map(({ name, effect }) => (
                    <tr key={uuid()}>
                        <td>{name}</td>
                        <td>{effect}</td>
                    </tr>
                ))}
            </Table>
        </ComponentsLayout>
    )
}

export default HelpersPage
